import { render } from "./ViewDvir.vue?vue&type=template&id=6d1184bc"
import script from "./ViewDvir.vue?vue&type=script&lang=js"
export * from "./ViewDvir.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__